var $ = require('jquery');
var maskLayer = require('./mask-layer');

var _singleton = maskLayer();
var _timeout;

function transformIcon(icon) {
    icon +='';
    if(icon.indexOf('fa-')===0){
        icon = '<i class="fa ' +icon+'"></i>';
    }
    return icon;
}

/**
 * toast 一般用于操作成功时的提示场景
 * @param {string} content toast的文字
 * @param {Object|function=} options 配置项或回调
 * @param {number=} [options.duration=3000] 多少毫秒后关闭toast
 * @param {function=} options.callback 关闭后的回调
 * @param {string=} options.className 自定义类名
 *
 * @example
 * trf.toast('操作成功', 3000);
 * trf.toast('操作成功', {
 *     duration: 3000,
 *     className: 'custom-classname',
 *     callback: function(){ console.log('close') }
 * });
 */
function toast(content, options) {
    var hideFlag = false;
    var maskContent = '';
    var defaultOptions = {
        content: content||'',
        icon:'',//可传font-awesome，例：'fa-check'|'fa-close'
        duration: 3000,
        callback: $.noop,
        className: ''
    };
    if (typeof options === 'number') {
        options = {
            duration: options
        };
    }
    if (typeof options === 'function') {
        options = {
            callback: options
        };
    }

    options = $.extend(defaultOptions, options);
    if($.type(options.duration)!=='number'){
        options.duration = defaultOptions.duration;
    }

    if(options.icon){
        maskContent +=  '<div class="icon">' +transformIcon(options.icon)+'</div>'
    }
    if(options.content){
        maskContent +=  '<div class="content">' +options.content+'</div>'
    }

    _singleton.getMaskLayer().removeClass().addClass('toast '+options.className);
    _singleton.getMaskContent().toggleClass('is-icon',!!options.icon).html(maskContent);
    _singleton.show();

    function hide(callback){
        if(!hideFlag){
            _singleton.hide(callback);
            hideFlag = true;
        }else {
            console.log('toast warning: hide方法至多调用一次有效')
        }
    }

    _timeout = setTimeout(function () {
        hide(options.callback);
    }, options.duration);

    return {
        hide:function (callback) {
            clearTimeout(_timeout);
            hideFlag || hide(callback);
        }
    };
}
module.exports = toast;



//////////////////
// WEBPACK FOOTER
// ./src/components/toast.js
// module id = 193
// module chunks = 0